import RadioControlLabel from './RadioControlLabel';

export default RadioControlLabel;
